import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

firebase.initializeApp({
    apiKey: "AIzaSyC--OFeTXhdTJxOq79c5dj4T_6Y9wPVB4c",
    authDomain: "teampower-11e55.firebaseapp.com",
    databaseURL: "https://teampower-11e55.firebaseio.com",
    projectId: "teampower-11e55",
    storageBucket: "teampower-11e55.appspot.com",
    messagingSenderId: "321744107844"
});

export const firestore = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();